import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=e6cfcf3e&scoped=true&"
import script from "./InvoicesTable.vue?vue&type=script&lang=js&"
export * from "./InvoicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cfcf3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6cfcf3e')) {
      api.createRecord('e6cfcf3e', component.options)
    } else {
      api.reload('e6cfcf3e', component.options)
    }
    module.hot.accept("./InvoicesTable.vue?vue&type=template&id=e6cfcf3e&scoped=true&", function () {
      api.rerender('e6cfcf3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShipmentsPage/InvoicesTable.vue"
export default component.exports